<template>
  <v-main>
    <v-btn @click="test()"> TEST </v-btn>
  </v-main>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {};
  },
  methods: {
    test() {
      var config = {
        method: "get",
        url:
          "https://payxtest.londonmultigames.com/api/payx-manager/transactions/0",
        headers: {
          Authorization:
            "Bearer eyJhbGciOiJIUzUxMiIsInR5cCI6IkpXVCJ9.eyJhcGl1c2VyIjoic3VwcG9ydCIsImxvZ2dlZEluIjoiRmFsc2UiLCJyb2xlIjoiU1VQUCIsIm5iZiI6MTYwNjEzNDQwMCwiZXhwIjoxOTIxNjY3MjAwLCJpYXQiOjE2MDYxMzQ0MDAsImlzcyI6InBheXgubG9uZG9ubXVsdGlnYW1lcy5jb20iLCJhdWQiOiJwYXl4LmxvbmRvbm11bHRpZ2FtZXMuY29tIn0.yBv0sdaOzLEUsrj0QEBSznTu68b00miTTpFo2tqy9mox03mU8KMxsY6OAYlwQpj0-q0yc2popThKCa2QT1BRKg"
        }
      };

      axios(config)
        .then(function(response) {
          console.log(JSON.stringify(response.headers["total-count"]));
        })
        .catch(function(error) {
          console.log(error);
        });
    }
  },
  async created() {},
  components: {}
};
</script>
<style scoped>
.centerImg {
  display: block;
  margin-left: auto;
  margin-right: auto;
  width: 50%;
}
</style>
